import {request} from "../../util/Request";
import Error from "../../util/Error";

const MANUFACTURER_MAIL_APPROVAL_FORM_STATE = {
    id: null,
    note: null,
}

export default {
    data() {
        return {
            manufacturerMailApprovalFormFields: {...MANUFACTURER_MAIL_APPROVAL_FORM_STATE}
        }
    },
    methods: {
        async handleManufacturerEmailApprovalSubmit() {
            try {
                const response = await request({
                    url: 'inbound/loads/manufacturer/approved',
                    method: 'post',
                    data: {...this.manufacturerMailApprovalFormFields}
                })

                this.manufacturerMailApprovalFormFields = {...MANUFACTURER_MAIL_APPROVAL_FORM_STATE}
                this.loadList()
            } catch (error) {
                if (error.request && error.request.status && error.request.status === 422) {
                    this.formErrors = new Error(JSON.parse(error.request.responseText).errors)
                    return false
                }

                this.handleServerError(error)
            }
        },
    }
}
